<template>
	<div id="loginform">
		<p style=";font-size: 42px;padding-bottom:20px;color: #55aaff;">VR宝箱网</p>
		账号<el-input v-model="name" placeholder="请输入账号" style="margin-bottom: 15px;"></el-input>
		密码：<el-input style="margin-bottom: 15px;" placeholder="请输入密码" v-model="password" show-password></el-input>
		<el-button style="width: 48%;" :loading="isloading" @click="isclick" type="primary">登录</el-button>
    <el-button style="width: 48%;" :loading="isloading" @click="isadduser" type="primary">注册</el-button>
	</div>
</template>

<script>
	export default{
		name:'loginform',
		props:{
			isloading:{
				type:Boolean,
				default:false
			}
		},
		data(){
			return{
				 name: null,
				 password: null
			}
		},
		methods:{
			isclick(){
				this.$emit('islogin',this.name,this.password)
			},
      isadduser(){
        this.$emit('isadduser',this.name,this.password)
      }
		}
	}
</script>

<style scoped>
	#loginform{
		width: 350px;
		position: absolute;
		font-weight: bold;
		color: #ff557f;
		left: 45%;
		top: 32%;
		padding: 15px;
		box-shadow: 0px 0px 5px 5px #e6e6e6;
	}

</style>
